import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, CheckIcon, XIcon } from 'lucide-react';
const FOR_WHOM = ['Para ti que todavía sientes miedo cuando la tierra cruje.', 'Para ti que lloras sin saber bien por qué desde ese día.', 'Para ti que quieres estar fuerte para tu familia pero por dentro estás agotada.', 'Para ti que necesitas un espacio seguro para procesar lo que viviste.', 'Para todo venezolano que pasó el 24 de junio y sigue de pie.'];
const IS_NOT = ['No es un manual de psicología.', 'No te va a decir que todo está bien cuando no lo está.', 'No ignora la realidad que vivimos.'];
export function ForYou() {
  return <section className="w-full bg-[#f3e9dd] px-6 py-16 sm:py-24" data-id="element-66" data-mp="3ht5ispkqpu7">
      <div className="mx-auto grid max-w-4xl gap-8 md:grid-cols-2" data-id="element-67" data-mp="3vog8nljf3kyh">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.7
      }} className="rounded-2xl bg-white/70 p-8 shadow-sm" data-id="element-68" data-mp="25aqwsk3pdad1">
          <div className="mb-5 flex items-center gap-3" data-id="element-69" data-mp="396seffv1qcsa">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#b06a4a]/15 text-[#b06a4a]" data-id="element-70" data-mp="397lfc07bq82i">
              <HeartIcon className="h-5 w-5" data-id="element-71" data-mp="3e4214nr1wacf" />
            </span>
            <h2 className="font-serif text-xl font-medium text-[#3a2e28]" data-id="element-72" data-mp="3ixn2mprurmgd">
              Para quién es esta guía
            </h2>
          </div>
          <ul className="space-y-4" data-id="element-73" data-mp="3nyat9ac661a2">
            {FOR_WHOM.map(t => <li key={t} className="flex gap-3 text-sm leading-relaxed text-[#5c4d44]" data-id="element-74" data-mp="3rvqcupxe0wsv">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#c9a24b]" data-id="element-75" data-mp="rruxa9vgcg6" />
                <span data-id="element-76" data-mp="5p0glku8aym6">{t}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="rounded-2xl bg-[#3a2e28] p-8 text-[#f3e9dd] shadow-sm" data-id="element-77" data-mp="22jwv191iyg1z">
          <h2 className="mb-5 font-serif text-xl font-medium" data-id="element-78" data-mp="1vgqbui2jjvsk">
            Lo que no es esta guía
          </h2>
          <ul className="space-y-4" data-id="element-79" data-mp="29grcbwew917i">
            {IS_NOT.map(t => <li key={t} className="flex gap-3 text-sm leading-relaxed text-[#e6d8ca]" data-id="element-80" data-mp="24f20iejukjid">
                <XIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#c9a24b]" data-id="element-81" data-mp="2if31du043qxu" />
                <span data-id="element-82" data-mp="2eej2olzw4f9l">{t}</span>
              </li>)}
          </ul>
          <p className="mt-6 border-t border-white/10 pt-6 font-serif text-base italic leading-relaxed text-[#f3e9dd]" data-id="element-83" data-mp="2ecgfe9q4h08k">
            Es un acompañamiento honesto, desde el corazón, para que encuentres tu
            centro aunque el suelo siga sintiéndose inestable.
          </p>
        </motion.div>
      </div>
    </section>;
}